import { color_groups as colorGroups } from '../../js/app/react/colors';
import { NetWorthColumn } from '../../js/app/react/chartDescriptors.overview';

const metricPrefixer = value => {
  if (value >= 1000000) {
    return `$${(value / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (value >= 1000) {
    return `$${(value / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  }
  if (value === 0) {
    return '$0';
  }
  if (value <= -1000000) {
    return `$${((value / 1000000) * -1).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (value <= -1000) {
    return `$${((value / 1000) * -1).toFixed(1).replace(/\.0$/, '')}K`;
  }
  return `$${value}`;
};

export const chartData = (state, clientId, range) => {
  const { NetWorthReport } = state;

  const netWorthReport = NetWorthReport[clientId];

  if (!netWorthReport) {
    return null;
  }

  if (netWorthReport.length === 0) {
    return null;
  }

  const {
    NetWorth: { History },
  } = netWorthReport;

  const data = (History || []).find(item => item.Title === range);

  const returnData = [
    {
      type: 'column',
      name: 'Assets',
      color: colorGroups[0][0],
      data: data.Data.Series.Assets,
      pointWidth: 100,
    },
    {
      type: 'column',
      name: 'Liabilities',
      color: colorGroups[3][2],
      data: data.Data.Series.Liabilities,
      pointWidth: 100,
    },
    {
      type: 'line',
      name: 'NetWorthChart',
      color: '#6C727F',
      data: data.Data.Series.NetWorth,
      marker: {
        radius: 5,
        fillColor: 'white',
        lineWidth: 2,
        lineColor: '#6C727F',
      },
    },
  ];

  // remove fixed width if we go beyond two sets of historical data
  if (data.Data.Series.Assets.length > 2) {
    delete returnData[0].pointWidth;
    delete returnData[1].pointWidth;
  }

  const localChartData = {
    ...NetWorthColumn,
    xAxis: { categories: data.Data.Categories },
    series: returnData,
  };

  return {
    ...localChartData,
    tooltip: {
      useHTML: true,
      shared: true,
      padding: 0,
      shadow: false,
      borderWidth: 0,
      backgroundColor: 'rgba(255,255,255,0)',
      borderRadius: 0,
      formatter() {
        return `
            <ul class="netWorthTooltip__List">
              <li class="netWorthTooltip__Item line"><i></i>Net Worth 
                <div class="value">${metricPrefixer(Math.abs(this.points[2].y))}</div>
              </li>
              <li class="netWorthTooltip__Item blue"><i></i>Assets 
                <div class="value">${metricPrefixer(this.points[0].y)}</div>
              </li>
              <li class="netWorthTooltip__Item purple"><i></i>Liabilities 
                <div class="value">${metricPrefixer(this.points[1].y * -1)}</div>
              </li>
            </ul>
          `;
      },
    },
  };
};
